module.exports = __webpack_public_path__ + "static/media/Tina.acc08e45.png";